import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import Cookies from "js-cookie";

const CenteredButton = ({ cookieData }) => {
  const [getCookieData, setGetCookieData] = useState("");

  useEffect(() => {
    const cookieValue = Cookies.get("trakdesk_cid");
    if (cookieValue) {
      setGetCookieData(JSON.parse(cookieValue)?.cid);
    }
  }, []);

  const handleClick = () => {
    window.location.href = `https://buy.stripe.com/eVaeWU9Zz7FPe4g4gi?client_reference_id=${getCookieData}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Button variant="contained" color="primary" onClick={handleClick}>
        Click Me
      </Button>
    </Box>
  );
};

export default CenteredButton;
